import { AppSubjectEnum } from '../../../shared/modules/authz/enums/app-subject.enum';
import { CaslSubject } from '../../../shared/modules/authz/decorators/casl-subject.decorator';
import { BaseSearchDto } from '../../../shared/modules/base/dtos/base-search.dto';
import { FileDto } from '../../../shared/modules/files/dtos/file.dto';
import { TagListDto } from '../../tags/dtos/tag-list.dto';

/**
 * Vehicle group DTO for searchable fields
 */
@CaslSubject(AppSubjectEnum.VEHICLE_GROUP)
export class VehicleGroupSearchDto extends BaseSearchDto {
  name!: string;
  files?: FileDto[] | null;
  tags?: TagListDto[] | null;
}
